/**
 * Placares oficiais da fase de grupos (chave: `${grupo}-${índice}` em gerarJogos).
 * Rodada do card = índices (rodada-1)*2 e (rodada-1)*2+1. Os índices seguem `gerarJogos`.
 */
export const PLACARES_OFICIAIS_GRUPOS = {
  "A-0": { casa: 1, fora: 1 },
  "A-1": { casa: 0, fora: 2 },
  "A-2": { casa: 2, fora: 1 },
  "A-3": { casa: 4, fora: 1 },
  "A-4": { casa: 1, fora: 1 },
  "A-5": { casa: 1, fora: 0 },
  "A-6": { casa: 1, fora: 1 },
  "A-7": { casa: 0, fora: 3 },
  "B-0": { casa: 0, fora: 0 },
  "B-1": { casa: 1, fora: 1 },
  "B-2": { casa: 0, fora: 2 },
  "B-3": { casa: 3, fora: 1 },
  "B-4": { casa: 4, fora: 2 },
  "B-5": { casa: 3, fora: 0 },
  "B-6": { casa: 2, fora: 1 },
  "B-7": { casa: 3, fora: 0 },
  "C-0": { casa: 1, fora: 0 },
  "C-1": { casa: 0, fora: 0 },
  "C-2": { casa: 1, fora: 1 },
  "C-3": { casa: 1, fora: 2 },
  "C-4": { casa: 2, fora: 0 },
  "C-5": { casa: 4, fora: 1 },
  "C-6": { casa: 1, fora: 1 },
  "C-7": { casa: 1, fora: 1 },
  "D-0": { casa: 0, fora: 1 },
  "D-1": { casa: 1, fora: 2 },
  "D-2": { casa: 1, fora: 2 },
  "D-3": { casa: 3, fora: 0 },
  "D-4": { casa: 1, fora: 0 },
  "D-5": { casa: 1, fora: 2 },
  "D-6": { casa: 0, fora: 0 },
  "D-7": { casa: 1, fora: 0 },
  "E-0": { casa: 0, fora: 2 },
  "E-1": { casa: 1, fora: 1 },
  "E-2": { casa: 2, fora: 0 },
  "E-3": { casa: 1, fora: 2 },
  "E-4": { casa: 2, fora: 0 },
  "E-5": { casa: 2, fora: 1 },
  "E-6": { casa: 1, fora: 1 },
  "E-7": { casa: 1, fora: 1 },
  "F-0": { casa: 1, fora: 0 },
  "F-1": { casa: 1, fora: 1 },
  "F-2": { casa: 1, fora: 0 },
  "F-3": { casa: 2, fora: 1 },
  "F-4": { casa: 1, fora: 1 },
  "F-5": { casa: 2, fora: 0 },
  "F-6": { casa: 0, fora: 1 },
  "F-7": { casa: 0, fora: 2 },
  "G-0": { casa: 1, fora: 0 },
  "G-1": { casa: 0, fora: 1 },
  "G-2": { casa: 1, fora: 0 },
  "G-3": { casa: 2, fora: 0 },
  "G-4": { casa: 1, fora: 0 },
  "G-5": { casa: 2, fora: 0 },
  "G-6": { casa: 4, fora: 0 },
  "G-7": { casa: 2, fora: 0 },
  "H-0": { casa: 3, fora: 1 },
  "H-1": { casa: 0, fora: 0 },
  "H-2": { casa: 0, fora: 1 },
  "H-3": { casa: 3, fora: 1 },
  "H-4": { casa: 2, fora: 3 },
  "H-5": { casa: 0, fora: 3 },
  "H-6": { casa: 1, fora: 0 },
  "H-7": { casa: 2, fora: 0 },
  "A-8": { casa: 1, fora: 0 },
  "A-9": { casa: 2, fora: 3 },
  "B-8": { casa: 0, fora: 0 },
  "B-9": { casa: 3, fora: 0 },
  "C-8": { casa: 2, fora: 1 },
  "C-9": { casa: 2, fora: 4 },
  "D-8": { casa: 1, fora: 1 },
  "D-9": { casa: 2, fora: 0 },
  "E-8": { casa: 1, fora: 1 },
  "E-9": { casa: 2, fora: 1 },
  "F-8": { casa: 0, fora: 1 },
  "F-9": { casa: 3, fora: 2 },
  "G-8": { casa: 2, fora: 0 },
  "G-9": { casa: 1, fora: 2 },
  "H-8": { casa: 4, fora: 1 },
  "H-9": { casa: 4, fora: 0 },
  "A-10": { casa: 3, fora: 0 },
  "A-11": { casa: 1, fora: 0 },
  "B-10": { casa: 1, fora: 0 },
  "B-11": { casa: 0, fora: 0 },
  "C-10": { casa: 3, fora: 1 },
  "C-11": { casa: 1, fora: 3 },
  "D-10": { casa: 0, fora: 1 },
  "D-11": { casa: 4, fora: 0 },
  "E-10": { casa: 0, fora: 1 },
  "E-11": { casa: 0, fora: 2 },
  "F-10": { casa: 4, fora: 1 },
  "F-11": { casa: 2, fora: 0 },
  "G-10": { casa: 3, fora: 2 },
  "G-11": { casa: 1, fora: 0 },
  "H-10": { casa: 1, fora: 0 },
  "H-11": { casa: 0, fora: 1 },
};

export function placarGrupoEhOficial(key) {
  return Object.prototype.hasOwnProperty.call(PLACARES_OFICIAIS_GRUPOS, key);
}
